import { withDirectModifiedFields } from 'utils/pendingChanges';

export class LoanApplicationNonBorrowersApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getNonBorrowersTableData({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/nonBorrowerEntities/view`),
    );
  }

  async getNonBorrowerData({ applicationId, nonBorrowerEntityId }) {
    return this.#http.get(
      `/api/applications/${applicationId}/nonBorrowerEntities/${nonBorrowerEntityId}`,
    );
  }

  async getNonBorrowersData({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/nonBorrowerEntities`);
  }
}
